import React from "react";
import { Modal } from "antd";

export interface ReusableModalProps {
  open: boolean;
  title?: string | React.ReactNode;
  onOk?: () => void;
  onCancel?: () => void;
  children?: React.ReactNode;
  width?: number | string;
  footer?: React.ReactNode | null;
  centered?: boolean;
  className?: string;
  destroyOnClose?: boolean;
}

const ReusableModal: React.FC<ReusableModalProps> = ({
  open,
  title,
  onOk,
  onCancel,
  children,
  width = 520,
  footer = null,
  centered = true,
  className = "",
  destroyOnClose = true
}) => {
  return (
    <Modal
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      width={width}
      footer={footer}
      centered={centered}
      destroyOnClose={destroyOnClose}
      className={className}
      title={
        typeof title === "string" ? (
          <div className="custom-page-header">{title}</div>
        ) : (
          title
        )
      }
    >
      {children}
    </Modal>
  );
};

export default ReusableModal;
